<template>
  <v-container class="home">
    <v-row class="mt-12">
      <v-card class="ma-auto col-6" outlined flat>
        <v-card-text>
          Fx Social is an algorithm that generates passive income in the forex market
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn href="mailto:fxsocialhelp@gmail.com?subject=I want to become an affiliate">
            Become An Affiliate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>

    <v-row class="ma-12">

      <v-card class="ma-auto" min-width="80%">
        <v-card-text>
          <v-text-field outlined v-model="affiliate" label="Affiliate ID" append-outer-icon="mdi-account-search" @click:append-outer="searchAffiliate"></v-text-field>
          <v-progress-linear v-if="loading" indeterminate/>
        </v-card-text>
      </v-card>

    </v-row>

    <v-row class="ma-12" v-if="purchases.length>0">

      <v-card
              class="mx-auto"
              width="80%"
              tile>

        <v-list disabled>
          <v-subheader>Referrals</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item
                    v-for="(purchase, i) in purchases"
                    :key="i"
            >
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="purchase.name"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-subtitle v-text="purchase.email"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>

    </v-row>

  </v-container>
</template>

<script>

import firebase from 'firebase/app'
import 'firebase/database'
const config = {
  apiKey: "AIzaSyBuhbDr6q9Kdf1pYTADFMNi5SxXoxqgY7o",
  authDomain: "fx-social-license.firebaseapp.com",
  databaseURL: "https://fx-social-license.firebaseio.com",
};
firebase.initializeApp(config);
const ref = firebase.database().ref('licenses');

export default {
  name: 'Home',
  data(){
    return{
      affiliate: "",
      purchases: [],
      loading: false
    }
  },
  methods:{
    searchAffiliate(){
      if (this.affiliate.length<20) {
        alert('Please Enter A Valid ID');
        return;
      }
      this.loading = true;
      ref.orderByChild('token').startAt(this.affiliate).endAt(this.affiliate).on('value', data => {
        this.purchases = [];
        this.loading = true;
        if (data.val() !== undefined && data.val() !== null){
          Object.entries(data.val()).forEach(([key, value]) => {
            let user = value;
            if (user.key===undefined) user.key = key;
            this.purchases.push(user);
          });
        }
        this.loading = false;
      })
    }
  }
}
</script>
